import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { defaultTheme } from '@shorelight/super-form/utils/ThemeUtils';

export const customThemeStyles = createMuiTheme({
  ...defaultTheme,
  typography: {
    typography: 'Rubik',
    ...defaultTheme.typography
  }
});
